import { render, staticRenderFns } from "./SalaryGroupCreateOrUpdate.vue?vue&type=template&id=4646e680&"
import script from "./SalaryGroupCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./SalaryGroupCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports